export const bigCheckIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-check-big.svg`,
  alt: "Green check icon"
}

export const searchMapIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/map-search.svg`,
  alt: "Map with a magnifying glass icon"
}

export const clipboardCheckIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/clipboard-check.svg`,
  alt: "Clipboard with a checkmark icon"
}

export const tableCheckIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/table-check.svg`,
  alt: "Table with a checkmark icon"
}

export const accountViewIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/account-view.svg`,
  alt: "Avatar with an eye next to it icon"
}

export const accountGreenIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/xs/account-green.svg`,
  alt: "Green avatar icon"
}

export const accountGreyIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/xs/account.svg`,
  alt: "Grey avatar icon"
}

export const demoViewIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/teacher-account-view.svg`,
  alt: "Teacher preview icon"
}

export const giftIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/gift.svg`,
  alt: "Gift icon"
}

export const groupAccountIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/account-group.svg`,
  alt: "Three avatars icon"
}

export const googleClassroomIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/google-classroom.svg`,
  alt: "Google Classroom icon"
}

export const helpIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-help.svg`,
  alt: "Question mark icon"
}

export const arrowPointingRightIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-arrow-back.svg`,
  alt: "Arrow pointing right icon"
}
export const whiteArrowPointingDownIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/downward-arrow-icon-white.svg`,
  alt: "White arrow pointing down icon"
}

export const expandIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/expand.svg`,
  alt: 'Expand icon'
}

export const fileChartIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-file-chart.svg`,
  alt: 'File with a chart icon'
}

export const fileDownloadIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-file-download.svg`,
  alt: 'File with a download icon'
}

export const horizontalDotsIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-more-horizontal.svg`,
  alt: 'Three horizontal dots icon'
}

export const playBoxIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-play-box.svg`,
  alt: 'Square play button icon'
}

export const previewIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-preview.svg`,
  alt: 'Eye icon'
}

export const smallWhiteCheckIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/shared/check-small-white.svg`,
  alt: 'Check icon'
}

export const indeterminateCheckIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/indeterminate.svg`,
  alt: 'Indeterminate check icon'
}

export const cursorClick = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/cursor-click.svg`,
  alt: 'Default cursor showing exaggerated clicking'
}

export const cursorPointingHand = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/cursor-pointinghand.svg`,
  alt: 'Cursor pointing hand'
}

export const removeIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-remove.svg`,
  alt: 'Icon showing a gray circle with a horizontal white line inside of it'
}

export const encircledWhiteArrowIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-arrow-right-circle-white.svg`,
  alt: 'Right arrow in a circle'
}

export const greenCheckIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/check-green.svg`,
  alt: 'Green check icon'
}

export const whiteCheckGreenBackgroundIcon = {
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-check-circle-dark.svg`,
  alt: 'White check with green background icon'
}

export const lockedIcon = {
  alt: 'Lock icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-locked.svg`
}

export const closeIcon = {
  alt: 'Close icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/close.svg`
}

export const informationIcon = {
  alt: 'Information icon',
  src: `${window.postbuildEnv.CDN_URL}/images/pages/evidence/icons-information-small.svg`
}

export const connectToolIcon = {
  alt: 'Target representing Quill Connect',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/connect-forest-green.svg`
}

export const diagnosticToolIcon = {
  alt: 'Magnifying glass representing Quill Diagnostic',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/diagnostic-forest-green.svg`
}

export const grammarToolIcon = {
  alt: 'Puzzle piece representing Quill Grammar',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/grammar-forest-green.svg`
}

export const lessonsToolIcon = {
  alt: 'Apple representing Quill Lessons',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/lessons-forest-green.svg`
}

export const proofreaderToolIcon = {
  alt: 'Flag representing Quill Proofreader',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/proofreader-forest-green.svg`
}

export const evidenceToolIcon = {
  alt: 'Book representing Quill Reading for Evidence',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/tool-evidence.svg`
}

export const warningIcon = {
  alt: 'Warning icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/warning-icon.svg`
}

export const disclosureIcon = {
  alt: '',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/disclosure.svg`
}

export const scheduledIcon = {
  alt: 'Clock icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/scheduled.svg`
}

export const publishedIcon = {
  alt: 'Checkmark icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/published.svg`
}

export const copyIcon = {
  alt: 'Two identical rectangles, one on top of the other',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/copy_icon.svg`
}

export const assignedBadgeIconGray = {
  alt: 'Gray silhouette of person with checkmark icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/assigned_badge.svg`
}

export const assignedBadgeIconWhite = {
  alt: 'White silhouette of person with checkmark icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/assigned_badge_white.svg`
}

export const infoIcon = {
  alt: '',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/info.svg`
}

export const closedLockIcon = {
  alt: 'Closed lock',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/locked.svg`
}

export const openLockIcon = {
  alt: 'Open lock',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/unlocked.svg`
}

export const networkIcon = {
  alt: 'Black silhouette of group of 4 people',
  src: `${window.postbuildEnv.CDN_URL}/images/onboarding/network.svg`
}

export const whiteDiamondIcon = {
  alt: 'White diamond',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/white-diamond.svg`
}
export const redDiamondIcon = {
  alt: 'Red diamond',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/red-diamond.svg`
}

export const evidenceHandbookIcon = {
  alt: 'Stack of papers with text "Quill Reading for Evidence Teacher Handbook"',
  src: `${window.postbuildEnv.CDN_URL}/images/evidence/evidence-teacher-handbook.svg`
}

export const filterIcon = {
  alt: 'Filter icon with three vertical dots and 3 horizontal lines',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/icons-filter.svg`
}

export const documentFileIcon = {
  alt: 'Document file with folded corner and two horizontal lines',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/file-document.svg`
}

export const singleUserIcon = {
  alt: 'Black silhouette of single user',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/single-user-icon-black.svg`
}

export const whiteEmailIcon = {
  alt: 'Envelope icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/email-icon-white.svg`
}

export const globeIcon = {
  alt: 'Globe icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/globe.svg`
}

export const aiIcon = {
  alt: 'Brain icon',
  src: `${window.postbuildEnv.CDN_URL}/images/icons/s/ai.svg`
}
